var exports = {
  "uW": "x234b8571--329cfb--filters",
  "p_": "x234b8571--329cfb--list",
  "sz": "x234b8571--329cfb--list__item",
};

module.exports = exports;
